var _style, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.7 166.8",
    style: {
      enableBackground: "new 0 0 167.7 166.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.9,89.2v45.1c0,0.3-0.2,0.5-0.4,0.6c-0.3,0.2-0.9,0.3-1.5,0l-40-21.5c-2.1-1.1-3.4-3.2-3.4-5.3V61.8 c0-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.3,0,0.5,0.1l40.1,21.5C78.4,84.4,79.9,86.8,79.9,89.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.4,63.1v44.8c0,3-1.9,5.8-4.8,7.4l-39.9,20.5c-0.2,0.1-0.4,0-0.5,0V89.3c0-2.5,1.5-4.9,4-6.1L131,62.7 c0.4-0.2,0.9-0.1,1.1,0C132.3,62.8,132.4,62.9,132.4,63.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.1,56.9c0,0.8-0.5,1.5-1.3,1.9L86.1,79.2c-0.9,0.5-2,0.5-3,0l-46.7-24C36.2,55,36,54.8,36,54.5 c0-0.3,0.2-0.5,0.5-0.7l39.7-20.4c1.2-0.6,2.5-0.9,3.8-0.9s2.6,0.3,3.8,0.9L125.8,55C126.6,55.5,127.1,56.1,127.1,56.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.9,17.4l-14,9.2c-0.9,0.6-2.1,0.3-2.6-0.6l-1.4-2.4c-0.6-0.9-0.3-2.1,0.7-2.6l6.4-4.5 c-20.2-3.2-39.4,4.1-52.2,20C5.1,54.7,2.8,79.7,13.5,102.2c0.3,0.7,0.1,1.6-0.7,2l-3,1.5c-0.9,0.4-1.9,0.1-2.3-0.8 c-11.8-24.7-9.2-52.4,7-72.6C28.8,14.5,50.3,6.4,72.9,9.9l-3.5-5.8c-0.5-0.9-0.3-2.1,0.7-2.6l2.4-1.4c0.9-0.5,2.1-0.3,2.6,0.7 l8.4,14C84.1,15.6,83.8,16.8,82.9,17.4z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.6,134.1c-14.3,17.8-35.8,26-58.4,22.4l3.5,5.8c0.5,0.9,0.3,2.1-0.7,2.6l-2.4,1.4 c-0.9,0.5-2.1,0.3-2.6-0.7l-8.4-14c-0.6-0.9-0.3-2.1,0.7-2.6l14-9.2c0.9-0.5,2.1-0.3,2.6,0.7l1.4,2.4c0.5,0.9,0.3,2.1-0.7,2.7 l-6.4,4.5c20.2,3.2,39.4-4.1,52.2-20c14.6-18.2,16.9-43.3,6.2-65.7c-0.4-0.7-0.1-1.6,0.7-2l3-1.5c0.8-0.4,1.9-0.1,2.3,0.8 C172.4,86.3,169.8,113.9,153.6,134.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/Model.00b3e33c69c436c48e4023efc5b105e9.svg";
export { ForwardRef as ReactComponent };